import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';
import Pagination from 'components/Libs/Pagination';
import TextField from 'material-ui/TextField';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

class AnnotationsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: this.props.annotations,
            searchText: '',
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    filterAnnotations(searchArray, searchText) {
        searchText = searchText.toLowerCase();

        return searchArray.filter((annotation) => {
            if (annotation.features) {
                if (annotation.features.rule)
                    if (annotation.features.rule.toLowerCase().includes(searchText))
                        return true;

                if (annotation.features.majorType)
                    if (annotation.features.majorType.toLowerCase().includes(searchText))
                        return true;

                if (annotation.features.string)
                    if (annotation.features.string.toLowerCase().includes(searchText))
                        return true;
            }

            if (annotation.type) {
                if (annotation.type.toLowerCase().includes(searchText)) {
                    return true;
                }
            }

            if (annotation.id) {
                const id = annotation.id + '';
                if (id.includes(searchText)) {
                    return true;
                }
            }

            return false;
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.annotations.length) {
            this.setState({
                annotations: props.annotations,
                total: props.annotations.length,
            }, () => {
                this.handleUpdateRow(this.state);
            });
        }
    }

    handleSearch(e) {
        const annotations = this.filterAnnotations(
            this.props.annotations,
            e.target.value,
        );

        this.setState({
            annotations,
            total: annotations.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.annotations.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    render() {
        let renderComponent = (<div className='annotations-list-b'>
            <div>
                <CircularProgress
                    className={this.props.isLoaded ? 'hidden' : ''}
                    style={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            </div>

            <div className={this.props.isLoaded ? 'navigation' : 'hidden'}>
                <div className='navigation-arrows'>
                    <Pagination
                        total={this.state.annotations.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        numberOfRows={this.state.numberOfRows}
                        updateRows={this.handleUpdateRow}
                    />
                </div>

                <div className='navigation-search'>
                    <TextField
                        hintText='Search'
                        hintStyle={{ fontSize: 12 }}
                        style={{ fontSize: 12 }}
                        onChange={this.handleSearch}
                    />
                </div>

                <div className='navigation-info'>
                    Total annotations: {this.state.annotations.length}
                </div>
            </div>

            <div className={this.props.isLoaded ? 'annotations-table' : 'hidden'}>
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow style={{ height: '28px' }}>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Value</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Rule</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Type</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>MajorType</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>id</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false}>
                        {
                            this.state.rows.map((annotation, i) => {
                                return (<TableRow style={{ height: '28px' }} key={i}>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.string}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.rule}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.type}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.majorType}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.id}</TableRowColumn>
                                </TableRow>);
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        </div>);
        let renderError = 'Something wrong with request';

        if (this.props.isError) {
            renderComponent = null;
        } else {
            renderError = null;
        }

        return (
            <div>
                {renderComponent}
                {renderError}
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            annotations: state.annotations.items,
            isLoaded: state.annotations.isLoaded,
            error: state.annotations.error,
            isError: state.annotations.isError,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(AnnotationsList);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Content/AnnotationsList.jsx